import { LinkResourcesSourceSettings } from '../link-resources';

export interface groupResourceSettings extends Omit<LinkResourcesSourceSettings, 'type'> {
  type: 'group-resources';
}
